import { render, staticRenderFns } from "./ProposalFilesCard.vue?vue&type=template&id=62b4a869&scoped=true&"
import script from "./ProposalFilesCard.vue?vue&type=script&lang=js&"
export * from "./ProposalFilesCard.vue?vue&type=script&lang=js&"
import style0 from "./ProposalFilesCard.vue?vue&type=style&index=0&id=62b4a869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b4a869",
  null
  
)

export default component.exports